import { type FC, useCallback } from 'react';

import { HEADER_HEIGHT } from '@/packages/hybrid-search-page-layout';
import {
  listingLayoutViewModeSelector,
  useListingLayoutFiltersHeightSelector,
  useListingLayoutViewModeSelector,
} from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { ViewModeSwitchers } from '../../components/ViewModeSwitchers';
import { useReduxState } from '../../context/ReduxStoreContext';
import { useViewModeChange } from '../../hooks/useViewModeChange';

const CONTAINER_OFFSET = 16;

export const ViewModeSwitchersContainer: FC = () => {
  const viewMode = useListingLayoutViewModeSelector();

  const switchToNextView = useViewModeChange();

  const reduxStore = useReduxState();

  const handleNarrowListToggle = useCallback(() => {
    const currentViewMode = listingLayoutViewModeSelector(reduxStore.getState());

    if (currentViewMode === 'hybrid') {
      switchToNextView('map', HEADER_HEIGHT);
    } else {
      switchToNextView('hybrid', HEADER_HEIGHT);
    }
  }, [reduxStore, switchToNextView]);

  const handleListModeSwitch = useCallback(async () => {
    switchToNextView('list');
  }, [switchToNextView]);

  const filtersHeight = useListingLayoutFiltersHeightSelector();

  if (viewMode === 'list') {
    return null;
  }

  return (
    <ViewModeSwitchers
      topOffset={filtersHeight + CONTAINER_OFFSET}
      viewMode={viewMode}
      onListModeSwitch={handleListModeSwitch}
      onNarrowListToggle={handleNarrowListToggle}
    />
  );
};
